import { useTranslate } from '../lib/i18n';
import Button from './common/Button';

interface IntakeWelcomeProps {
  onContinueWithPassword: () => void;
  onStartNew: () => void;
}

const IntakeWelcome = ({ onStartNew, onContinueWithPassword }: IntakeWelcomeProps) => {
  const t = useTranslate();

  return (
    <div className="min-h-full flex flex-col max-w-lg mx-auto justify-between px-4">
      <div className="flex-1 flex items-center">
        <div className="w-full space-y-12 my-8 text-center">
          <div className="border bg-card rounded p-4 space-y-4">
            <h1>{t('SurveyTool.passwordWelcome.title')}</h1>
            <p className="text-sm text-muted-foreground">
              {t('SurveyTool.passwordWelcome.description')}
            </p>

            <Button variant="primary" onClick={onStartNew}>
              {t('SurveyTool.passwordWelcome.startNew')}
            </Button>
          </div>

          <div className="space-y-2">
            <p className="text-sm text-muted-foreground text-center">
              {t('SurveyTool.passwordWelcome.previousReportComment')}
            </p>

            <Button variant="secondary" onClick={onContinueWithPassword}>
              {t('SurveyTool.passwordWelcome.continueWithPassword')}
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full my-2 text-xs text-muted-foreground">
        <img src="/assets/invictus-logo.png" alt="Invictus Logo" className="mx-auto mb-2 h-6" />
        <div>{t('SurveyTool.disclaimer')}</div>
      </div>
    </div>
  );
};

export default IntakeWelcome;
